/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect, useState } from 'react';
import './../../../assets/styles/coupon-banner.css'; // import styles
 
import { getCoupons } from '../../subscription/core/_requests';
import { useNavigate } from 'react-router-dom';

const CouponBanner = () => {
    const [coupons, setCoupons] = useState<any>({});
    const [amountType, setAmountType] = useState<any>({});
    const naviagate = useNavigate();
    useEffect(() => {
    const fetchCoupon = async () => {
      try {
        const data = await getCoupons(2); 
        setCoupons(data?.data[0]); // assuming it's an array
        if (data?.data[0].couponValueType === 1) { 
         setAmountType("%");
        } else   {
          
          setAmountType("$");
        }
      } catch (err) {
        console.error("Error fetching coupon:", err);
      }
    };

    fetchCoupon();
  }, []); 
  function handleClick(){
naviagate("/subscription/list")
  }
  
  if (!coupons || !coupons?.description) {
    return null;
  }
    const formattedDate = new Date(coupons?.endDate).toLocaleDateString('en-US', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
   hour: "2-digit",
    minute: "2-digit",
    timeZoneName: "short",
});
  return ( 

    <div className="offer-container">
      <div  className="offer-text" id="scrollText">
    
      <span
      className="hoverTarget" onClick={() => handleClick()}
      onMouseEnter={() => {
        const el = document.getElementById('scrollText');
        if (el) el.style.animationPlayState = 'paused';
      }}
      onMouseLeave={() => {
        const el = document.getElementById('scrollText');
        if (el) el.style.animationPlayState = 'running';
      }}
    >Save – {coupons?.amount}{coupons?.couponValueType === 1 ? "%" : "$"} on  {coupons?.planId!="00000000-0000-0000-0000-000000000000" ? `${coupons?.plan} plan to` : ""}   your chef subscription – Offer Ends {formattedDate}.
 
 </span>
      </div>
    </div>
  );
};

export default CouponBanner;